export enum ResultStatus {
  Unknown = 0,
  Green = 1,
  Amber = 2,
  Red = 3,
  DomesticSegmentCustomStatus = 10 // Client application only status https://ictseuropesystems.visualstudio.com/defaultcollection/All/_boards/board/t/TravelDoc%20Website/Stories/?workitem=8796
}
